import React from "react";
import { Box, Flex, Text } from "@radix-ui/themes";
import Button from "../Button";
import styles from "./styles.module.scss";

const Card = ({
  image,
  imagePosition = "left",
  subtitle,
  title,
  description,
  button,
  backgroundColor = "var(--color-primary)",
  cardBackgroundColor = "white",
  textColor,
  roundImage,
  imageMaxHeight,
  descriptionEmphasis,
  sectionPadding,
  cardPadding,
  className,
  cardClassName,
}) => {
  const isImageLeft = imagePosition === "left";

  return (
    <Box className={`${styles.section} ${className || ""}`} style={{ backgroundColor, padding: sectionPadding }}>
      <Box className={`${styles.card} ${cardClassName || ""}`} style={{ backgroundColor: cardBackgroundColor, padding: cardPadding }}>
        <Flex
          direction={{ initial: "column", md: "row" }}
          align="center"
          gap="5"
          className={styles.cardContent}
          style={{ flexDirection: isImageLeft ? "row" : "row-reverse" }}
        >
          {/* Image */}
          <Box className={styles.imageContainer}>
            <img
              src={image}
              alt={title}
              className={styles.image}
              style={{
                borderRadius: roundImage ? "50%" : undefined,
                width: roundImage ? "180px" : undefined,
                height: roundImage ? "180px" : undefined,
                objectFit: roundImage ? "cover" : undefined,
                maxHeight: imageMaxHeight || undefined,
              }}
            />
          </Box>

          {/* Content */}
          <Flex direction="column" gap="4" className={styles.textContent}>
            {subtitle && (
              <Text className={styles.subtitle} style={textColor ? { color: textColor } : {}}>{subtitle}</Text>
            )}
            <Text className={styles.title} style={textColor ? { color: textColor } : {}}>{title}</Text>
            <Text
              className={styles.description}
              style={{
                ...(textColor ? { color: textColor } : {}),
                ...(descriptionEmphasis ? { fontSize: "28px", fontWeight: 700 } : {}),
              }}
            >
              {description}
            </Text>
            {button && (
              <Box className={styles.buttonContainer}>
                <Button
                  variant={button.variant || "normal"}
                  size={button.size || "3"}
                  onClick={button.onClick}
                  backgroundColor={button.backgroundColor || "var(--color-primary)"}
                  textColor={button.textColor || "var(--color-secondary)"}
                >
                  {button.label}
                </Button>
              </Box>
            )}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Card;
